"use client";

import { createContext, useContext } from "react";
import type { StockDisplay } from "@/lib/brand/types";

/**
 * Exposes the store's stock-display preference (Settings → Products) to client
 * components anywhere in the storefront — the PDP StockBadge and product cards —
 * without prop-threading through every list path. Defaults to 'badge' (the
 * historical behavior) when no provider is present.
 */
const StockDisplayContext = createContext<StockDisplay>("badge");

export function StockDisplayProvider({
  value,
  children,
}: {
  value: StockDisplay;
  children: React.ReactNode;
}) {
  return (
    <StockDisplayContext.Provider value={value}>
      {children}
    </StockDisplayContext.Provider>
  );
}

export function useStockDisplay(): StockDisplay {
  return useContext(StockDisplayContext);
}
